/* eslint-disable @typescript-eslint/no-var-requires */
import type { UserType } from "@/generated/graphql"
import { useStore } from "@nanostores/react"
import { atom, onMount, task } from "nanostores"
import config from "@/config"
import { type Href, router } from "expo-router"
import { $originalUrlBeforeLoginRedirect } from "@/stores/originalLoginUrl"

const isBrowserEnv = () => typeof window !== `undefined`

const $latestBranchOpenEvent = atom<null>(null)

onMount($latestBranchOpenEvent, () => {
  if (isBrowserEnv()) {
    void task(async () => {
      const branch = require("branch-sdk")
      branch.init(config.BRANCH_API_KEY)
    })
  }
})

export const useLatestBranchOpenEvent = () => {
  return useStore($latestBranchOpenEvent)
}

export const useDeepLinkReroute = () => {
  return (routeTo: Href = "/") => {
    const url = $originalUrlBeforeLoginRedirect.get() || routeTo
    $originalUrlBeforeLoginRedirect.set(null)
    console.log("redirecting to: " + (url as string))
    router.replace(url)
  }
}

export interface BranchReferralLinkProps {
  user: UserType
}

export const createBranchReferralLink = ({ user }: BranchReferralLinkProps) => {
  console.log({ user })
  return `${config.BRANCH_URL}?code=${user.referralCode}`
}

export interface BranchAnalysisShareLinkProps {
  user: UserType
  analysisId: string
  street?: string | null
  imageUrl?: string | null
}

export const createBranchAnalysisShareLink = async ({
  user,
  analysisId,
  street,
  imageUrl,
}: BranchAnalysisShareLinkProps) => {
  const branch = require("branch-sdk")
  let title = "Backflip Analysis"
  if (street) {
    title = `Backflip analysis on ${street}`
  }
  const contentDescription = `Check out the RE investment analysis I've created using the Backflip app for ${street || "this property."}`

  return await new Promise((resolve, reject) => {
    branch.link(
      {
        data: {
          $og_title: title,
          $og_description: contentDescription,
          $og_image_url: imageUrl || undefined,
          $canonical_identifier: `analyzer/${analysisId}`,
          code: user.referralCode || "",
        },
      },
      (err: branch.BranchError, link: string | null) => {
        if (err) {
          reject(err)
          return
        }
        resolve(link)
      }
    )
  })
}
